import { render, staticRenderFns } from "./showCode.vue?vue&type=template&id=09612990"
import script from "./showCode.vue?vue&type=script&lang=js"
export * from "./showCode.vue?vue&type=script&lang=js"
import style0 from "./showCode.vue?vue&type=style&index=0&id=09612990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports